var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFemaleBadge = function SvgFemaleBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.27,
    height: 16.801,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25.27,
    height: 16.801,
    x: 0.5,
    y: 0.5,
    stroke: "#7F00FF",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F00FF",
    d: "M18.97 11.48v-1.342c-1.43-.187-2.551-1.375-2.551-2.893a2.918 2.918 0 0 1 2.925-2.926 2.925 2.925 0 0 1 2.926 2.926 2.889 2.889 0 0 1-2.54 2.893v1.342h1.485v.76H19.73v1.451h-.76V12.24h-1.495v-.759h1.495m-1.704-4.235c0 1.144.902 2.134 2.079 2.134 1.166 0 2.079-.99 2.079-2.134 0-1.166-.913-2.134-2.08-2.134-1.177 0-2.079.968-2.079 2.134M9.269 10.094l.022-.902h1.551V6.948H9.291l-.022-.913h1.573V4h1.133v9.801h-1.133v-3.707zM4 8.18c0-2.068.946-3.454 2.464-3.454s2.475 1.386 2.475 3.465c0 2.057-.957 3.443-2.475 3.443C4.946 11.634 4 10.248 4 8.18m3.85 0c0-1.562-.561-2.541-1.386-2.541-.814 0-1.364.979-1.364 2.541 0 1.573.55 2.552 1.364 2.552.825 0 1.386-.979 1.386-2.552"
  })));
};
export default SvgFemaleBadge;